import React from "react";
import { useParams, Link } from "react-router-dom";
import MarkdownRenderer from "../common/MarkdownRenderer";
import { getExperience } from "../../lib/loadContent";

const ExperienceDetail = () => {
  const { slug } = useParams();
  const experience = getExperience(slug);

  if (!experience) {
    return (
      <div className="page">
        <h1 className="page-title">404</h1>
        <p>
          Experience <code>{slug}</code> not found.
        </p>
        <Link to="/experience">← back to experience</Link>
      </div>
    );
  }

  return (
    <article className="page experience-detail">
      <div className="experience-detail-head">
        <div>
          <h1 className="page-title">{experience.title}</h1>
          <p className="page-path">
            {experience.company} · {experience.date} · ~/portfolio/experience/
            {experience.slug}.md
          </p>
        </div>
        {experience.logo && (
          <img
            className="experience-detail-logo"
            src={experience.logo}
            alt={`${experience.company} logo`}
          />
        )}
      </div>
      <MarkdownRenderer>{experience.content}</MarkdownRenderer>
    </article>
  );
};

export default ExperienceDetail;